// ============================================================================
// view.broilerweighins — shared livestock session census, localized
// ============================================================================
// Broiler and pig weigh-ins mount the same list component. The shared resource
// is keyed by the route's literal species parameter, so this declaration owns
// only the broiler view's session/entry census and cannot reuse pig data.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.broilerweighins',
  obligations: Object.freeze([Object.freeze({id: 'livestock.weighins.list', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
